import RegistrationService from '@app/model/registration/service/RegistrationService';
import useBaseRegistrationAccountSetupFlowHook
	from '@app/site/system/component/BaseAccountSetupFlowHook';
import ProcessRequestType from '@app/model/process_request/ProcessRequestType';


const useExecuteRegistrationEnrichHotelsHook = () => {

	const START_FUNCTION = RegistrationService.runEnrichCompanyHotels;
	const FINISH_FUNCTION = RegistrationService.finishEnrichCompanyHotels;

	const baseRegistrationAccountSetupFlowHook = useBaseRegistrationAccountSetupFlowHook(ProcessRequestType.REGISTRATION_HOTEL_INFO, START_FUNCTION, FINISH_FUNCTION);

	return {
		start: baseRegistrationAccountSetupFlowHook.start,
		finish: baseRegistrationAccountSetupFlowHook.finish,
		isFinished: baseRegistrationAccountSetupFlowHook.isFinished,
	};

};

export default useExecuteRegistrationEnrichHotelsHook;